<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active="loadingPaciente"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <div v-if="!loadingPaciente">
      <div v-if="blnClinicaDescentralizada">
        <!-- <pacienteV2 v-if="blnClinicaDescentralizada"></pacienteV2> -->
         <PerfilPacienteNuevo v-if="blnClinicaDescentralizada"/>
      </div>
    </div>
  </div>
</template>

<script>
/* import PacienteV2 from "./PacienteV2"; */
import PerfilPacienteNuevo from './PerfilPacienteNuevo';

export default {
  name: "Paciente",
  components: {
    PerfilPacienteNuevo
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    blnClinicaDescentralizada: false,
    loadingPaciente: true
  }),

  //comment to commit
  async created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    this.obtenerClinicaTieneDesentralizado();
  },
  methods: {
    obtenerClinicaTieneDesentralizado() {
      this.loadingPaciente = true;
      const parametros = {
        idClinica: this.$localStorageService.getIdClinica(),
        idConfiguracion: 2
      }
      this.$http
          .post(
              this.$api +
              "configuracionClinica/obteneValidacionConfiguracionClinica", parametros
          )
          .then((response) => {
            this.blnClinicaDescentralizada = response.data.data;
          }).finally(()=>this.loadingPaciente = false)
    },
  },
  watch: {
    '$route.params': {
      handler: function () {
        location.reload();
      },
      deep: true,
    }
  }
};
</script>

<style scoped>

</style>
